interface IHostsList {
  [key: string]: string;
  development: string;
  production: string;
  staging: string;
}

const assetHosts: IHostsList = {
  development: '',
  production: 'https://suz.uc-gpb.ru',
  staging: 'https://suz.uc-gpb.ru',
}

const gispHosts: IHostsList = {
  development: '',
  production: 'https://gisp.gov.ru',
  staging: 'https://test.gisindustry.ru',
}

export const environment: string = process.env.RAILS_ENV

export const assetHost: string = assetHosts[environment]

export const gispHost: string = gispHosts[environment]

export const isProduction: boolean = ('production' === environment)

export const isStaging: boolean = ('staging' === environment)

export const isDevelopment: boolean = ('development' === environment)

export const isGispOrigin: boolean = (window.location.origin === gispHost)

export const isOrigin: boolean = (window.location.hostname === 'localhost' || window.location.origin === assetHost)

export const toString = (): string => environment
